<template>
  <div
      class="hide-overflow"
      style="position: relative; height: 100%"
  >
    <v-toolbar absolute
               color="primary"
               flat>
      <img src="@/assets/logo.png" height="35"/>
    </v-toolbar>
    <v-container style="margin-top: 64px; height: calc(100% - 64px)">
      <v-layout fill-height>
        <div class="chatview-content" ref="content">
          <div id="loading" v-if="loading">
            <v-progress-circular
                :size="20"
                :width="2"
                color="green"
                indeterminate
            ></v-progress-circular>
          </div>
          <div>
            <div class="msg-holder" v-for="msg in chatLog" :key="'msg_index_' + msg.id">
              <div class="session_hr_time" v-if="msg.first_session">
                <hr>
                <span class="span-session">{{ formatDateTime(msg.created_time) }}</span>
              </div>
              <Message
                  v-if="accept_message_types.includes(msg.type)"
                  :message="msg"
                  :customer="customer"
                  :isLastSeenMsg="false"
              ></Message>
            </div>
          </div>
        </div>
      </v-layout>
    </v-container>
    </div>
</template>

<script>
import BotService from "@/services/bot.service";
import messageHandler from '@/services/message_handlers/supporter_handler_message.js';
import Message from "components/message-box/content/Message";
import utils from "@/services/utils";

const moment = require('moment');

const ChatLogSource = {
  RECEIVE: 1,  // tin nhắn nhận từ người dùng
  SEND: 2,  // tin nhắn từ hệ thống gửi cho người dùng
};
const MessageSource = {
  NORMAL: 1,  // Tin nhắn bình thường ngời dùng vs bot, bot vs ng
  SYSTEM: 2,  // Tin nhắn từ hệ thống tới người dùng (broadcast) -> Deprecated
  ADMIN: 3,  // Admin gửi tin nhắn đến người dùng, người dùng chat với admin
  SEND_BROADCAST: 4,  // Send broadcast
  SEND_REMINDER: 5,  // Send reminder
  CALL_SEND_MESSAGE_API: 6,  // Send message controllers
};

export default {
  name: "HistoryBySession",
  components: {
    Message,
  },
  data() {
    return {
      loading: true,
      chatLog: [],
      accept_message_types: utils.viewableMessageType,
      shouldLoadChatLogOnScroll: false,
      paramsLoadChatLogs: '',
      canLoadMoreChatLogs: false,
      customerInfo: {}
    }
  },
  computed: {
    customer () {
      return {
        name: this.customerInfo.sender_name,
        image: this.customerInfo.sender_name,
        channel: this.customerInfo.sender_channel
      }
    }
  },
  mounted() {
    this.chatLog = [];
    this.getConversationHistory();
    this.$nextTick(() => {
      let element = this.$refs.content;
      if (!element.hasAttribute('scroll')) {
        element.addEventListener('scroll', this.eventScrollChatlogs);
      }
    });
  },
  methods: {
    isUser(msg) {
      return msg.source === ChatLogSource.RECEIVE
    },
    isBot(msg) {
      return msg.sender_type !== MessageSource.ADMIN && msg.source === ChatLogSource.SEND
    },
    isAdmin(msg) {
      return msg.sender_type === MessageSource.ADMIN && msg.source === ChatLogSource.SEND
    },
    formatDateTime(time) {
      return moment(time).format('DD/MM/YYYY HH:mm')
    },
    handler_chatlog_msg(msg) {
      let acceptMsg = messageHandler.handler_message(msg, this.customer.channel);
      acceptMsg.isLastMsg = true;
      let lengthMsg = this.chatLog.length;
      if (lengthMsg > 0) {
        acceptMsg.isFirstMsg = acceptMsg.source !== this.chatLog[lengthMsg - 1].source
        if (acceptMsg.source === this.chatLog[lengthMsg - 1].source) {
          this.chatLog[lengthMsg - 1].isLastMsg = false;
        }
      } else {
        acceptMsg.isFirstMsg = true;
      }
      this.chatLog.unshift(acceptMsg);
    },
    async getConversationHistory(nextUrl = '') {
      const botCode = this.$route.params.bot_code;
      const senderId = this.$route.params.sender_id;
      const sessionId = this.$route.params.session_id
      this.customerInfo = (await BotService.getCustomerInfo(botCode, senderId)).data
      await BotService.getChatLogBySessionID(botCode, senderId, sessionId, nextUrl).then(
          (res) => {
            for (let log of res.data.chatlog) {
              if (log.message_type !== "request_human_support" && log.message_type !== "typing") {
                log.sender_type = log.type;
                log.supporter = log.extra;
                log.first_session = false;
                let log_message = {...JSON.parse(log.message)}
                for (let key of Object.keys(log_message)) {
                  if (key !== "source") {
                    log[key] = log_message[key];
                  }
                }
              }
              this.handler_chatlog_msg(log)
            }
            this.loading = false;
            this.$nextTick(this.scrollBottom);
            this.paramsLoadChatLogs = res.data.next ? res.data.next : '';
            this.canLoadMoreChatLogs = this.paramsLoadChatLogs !== '';
            this.shouldLoadChatLogOnScroll = true;
          })
    },
    scrollBottom() {
      let element = this.$refs.content;
      element.setAttribute('style', 'scroll-behavior: auto;');
      element.scrollTop = element.scrollHeight - element.clientHeight;
      element.setAttribute('style', 'scroll-behavior: smooth;');
    },
    sortChatLog(chatLogs) {
      chatLogs.sort(function (a, b) {
        return b.created_time.localeCompare(a.created_time);
      });
      return chatLogs
    },
    async eventScrollChatlogs() {
      if (this.shouldLoadChatLogOnScroll) {
        let objChatBox = this.$refs.content;
        if (objChatBox.scrollTop === 0) {
          if (this.canLoadMoreChatLogs) {
            this.scrollPosition = objChatBox.scrollHeight;
            this.loading = true;
            await this.getConversationHistory(this.paramsLoadChatLogs);
            this.$nextTick(function () {
              this.loading = false;
              // scroll
              objChatBox.setAttribute('style', 'scroll-behavior: auto;');
              objChatBox.scrollTop = objChatBox.scrollHeight - this.scrollPosition - 22;
              objChatBox.setAttribute('style', 'scroll-behavior: smooth;');
            });

          }
        }
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.content) {
      this.$refs.content.removeEventListener('scroll', this.eventScrollChatlogs);
    }
  },
}
</script>

<style scoped lang="scss">
@import "components/style/variables.scss";
.chatview-content {
  overflow: auto;
  padding: 10px 20px;
  scroll-behavior: smooth;
  z-index: 1;
  position: relative;
  height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .content-row {
    padding: 5px 0;
    display: flex;
    align-items: center;

    &.left {
      flex-direction: row;

      .content-wrapper {
        background: #fff;
      }
    }

    &.right {
      flex-direction: row-reverse;

      .content-wrapper {
        background: #4977EE;
        color: #fff;
      }
    }

    .content-icon {
      width: 30px;
      height: 30px;
    }

    .content-wrapper {
      border-radius: 5px;
      padding: 5px;
      margin: 0 5px;
    }

    .content-time {
      color: #999;
      font-size: 0.7em;
    }
  }

  .msg-holder {
    display: block;
    width: 100%;
    float: left;
  }

  #loading {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center
  }
}
</style>
